import { ACTIONS } from "UTILS/Constants";
import BaseAction from "CONFIG/BaseAction";

export class CallWaitingAction extends BaseAction {
  constructor() {
    super();
    BaseAction.call(this);
  }

  setOperatorStatus(operatorStatus) {
    this.dispatch({
      type: ACTIONS.SUPPORT_CENTER.SET_OPERATOR_STATUS,
      value: operatorStatus,
    })
  }

  setIsTransferError(IsTransferError) {
    this.dispatch({
      type: ACTIONS.SUPPORT_CENTER.SET_IS_TRANSFER_ERROR,
      value: IsTransferError,
    });
  }

  setTransferDestinationOperatorList(transferDestinationOperatorList) {
    this.dispatch({
      type: ACTIONS.SUPPORT_CENTER.SET_CALL_TRANSFER_INFO,
      value: transferDestinationOperatorList,
    });
  }

  setIsWebWorkerError(isWebWorkerError) {
    this.dispatch({
      type: ACTIONS.SUPPORT_CENTER.SET_IS_WEB_WORKER_ERROR,
      value: isWebWorkerError,
    });
  }
}
